import React, { FC } from 'react';
import { DateRangeSelector } from '@cokitchen/cokitchen-components';
import { PaymentFilterType } from './types';
import PartnerSelector from 'components/base/partner-selector';

type Props = {
  value: PaymentFilterType;
  onChange: (e: PaymentFilterType) => void;
};

const PaymentHistoryHeader: FC<Props> = ({ value, onChange }) => {
  return (
    <div className='flex flex-col md:flex-row gap-2 md:items-center justify-between mb-8'>
      <PartnerSelector
        partnerId={value.partnerId}
        setPartnerId={(partnerId) => onChange({ ...value, partnerId })}
      />
      <div className='flex items-center'>
        <label htmlFor='' className='mr-3'>
          Overview period:
        </label>
        <DateRangeSelector
          onChange={(dateRange) => onChange({ ...value, dateRange })}
          defaultRange={value.dateRange.range}
        />
      </div>
    </div>
  );
};

export default PaymentHistoryHeader;
